import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType, computed } from "vue";
/**
 * Пропсы
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-indicator',
  props: {
  /**
   * Цифра активного состояния
   */
  activeContent: { type: Number as PropType<number>, default: null },
  /**
   * Размер
   */
  size: {
    type: String as PropType<"xxxl" | "xxl" | "xl" | "l" | "m" | "s" | "xs">,
    default: "xxl",
  },
  /**
   * С обводкой
   */
  isBordered: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /**
   * Вариант цвета
   */
  variant: {
    type: String as PropType<"accent" | "secondary" | "tertiary">,
    default: "accent",
  },
  /**
   * Кастомный цвет
   */
  customColor: {
    type: String as PropType<string>,
  },
},
  setup(__props) {

const props = __props;



const calcAddPlusToSign = computed(() => {
  if (props.activeContent > 99) {
    return "99+";
  } else if (props.size == "xs" || props.size == "m" || props.size == "s") {
    return undefined;
  } else {
    return props.activeContent;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["indicator", {
      'indicator--bordered': props.isBordered,
      'indicator--size-xxxl': props.size == 'xxxl',
      'indicator--size-xxl': props.size == 'xxl',
      'indicator--size-xl': props.size == 'xl',
      'indicator--size-l': props.size == 'l',
      'indicator--size-m': props.size == 'm',
      'indicator--size-s': props.size == 's',
      'indicator--size-xs': props.size == 'xs',
      'indicator--variant-accent': props.variant == 'accent',
      'indicator--variant-secondary': props.variant == 'secondary',
      'indicator--variant-tertiary': props.variant == 'tertiary',
      'indicator--with-custom-color': props.customColor,
    }]),
    style: _normalizeStyle({
      'background-color': props.customColor,
    })
  }, _toDisplayString(calcAddPlusToSign.value), 7))
}
}

})